module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(" 这个页面是 1号页面 ")]), _vm._v("\n  " + _vm._s(_vm.points) + " "), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "点击增加1"
    },
    on: {
      "click": _vm.increase
    }
  }), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ShowCounter2'
      }
    }
  }, [_vm._v("\n        计时页面2\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a1b937e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShowCounter1.vue
// module id = 68
// module chunks = 0